import React from 'react';
import { Link } from 'react-router-dom';
import { AlertOctagon, ArrowDown, ArrowRight, Car, CheckCircle2, FileCheck as FileCheck2, Hand, QrCode, Smartphone, User, UserCheck, Users } from 'lucide-react';
import { PageHeader } from '../../components/common/PageHeader';
import { Panel } from '../../components/common/Panel';
import { toBn } from '../../utils/bn';
const steps = [{
  icon: Hand,
  label: 'সিএনজি থামান',
  sub: 'চেকপয়েন্টে সংকেত'
}, {
  icon: QrCode,
  label: 'QR স্ক্যান',
  sub: '২–৩ সেকেন্ড'
}, {
  icon: Car,
  label: 'গাড়ির তথ্য দেখুন',
  sub: 'নিবন্ধন, ফিটনেস, ট্যাক্স'
}, {
  icon: User,
  label: 'মালিকের তথ্য দেখুন',
  sub: 'BRTA যাচাইকৃত'
}, {
  icon: Users,
  label: '৩ জন অনুমোদিত চালক দেখুন',
  sub: 'ছবিসহ তালিকা'
}, {
  icon: UserCheck,
  label: 'বর্তমান চালক নির্বাচন',
  sub: 'চেহারা মিলিয়ে / কার্ড স্ক্যান'
}, {
  icon: FileCheck2,
  label: 'লাইসেন্স/ফিটনেস যাচাই',
  sub: 'স্বয়ংক্রিয়'
}];
export function RoadsideJourney() {
  return <div className="space-y-4" data-id="element-3773" data-mp="vxsy483z3kmy">
      <PageHeader title="ট্রাফিক পুলিশ রোডসাইড যাচাই যাত্রা" subtitle="একটি সিএনজি যাচাই সম্পন্ন করতে গড়ে ৪৫ সেকেন্ডেরও কম সময়" actions={<Link to="/mobile" className="flex items-center gap-1.5 rounded-md bg-navy-800 px-3 py-2 text-sm font-semibold text-white" data-id="element-3775" data-mp="2cv7n7fuhd7ih"><Smartphone className="h-4 w-4" data-id="element-3776" data-mp="2rm6qqcggl5v7" />মোবাইল অ্যাপে দেখুন</Link>} data-id="element-3774" data-mp="2huauz81uhru5" />
      <Panel data-id="element-3777" data-mp="2mm2l5hh39vjr">
        <ol className="grid gap-3 md:grid-cols-4 xl:grid-cols-7" data-id="element-3778" data-mp="2mndm79j5gp76">
          {steps.map((s, i) => <li key={s.label} className="relative" data-id="element-3779" data-mp="1yxje159rzot9" data-mpi={i}>
              <div className="flex h-full flex-col items-center rounded-lg border border-navy-100 bg-navy-50/50 p-4 text-center" data-id="element-3780" data-mp="1txn7ozdlvlaj">
                <span className="mb-1 text-[11px] font-bold text-navy-500" data-id="element-3781" data-mp="27xpoeia6g8o7">{toBn(i + 1)}</span>
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-navy-800 text-white" data-id="element-3782" data-mp="23thum6ov42j4"><s.icon className="h-6 w-6" strokeWidth={1.8} data-id="element-3783" data-mp="3j9qfi3uik974" /></span>
                <p className="mt-2 text-sm font-semibold leading-snug text-navy-900" data-id="element-3784" data-mp="3f8wsdcowayfa">{s.label}</p>
                <p className="mt-0.5 text-[11px] text-slate-500" data-id="element-3785" data-mp="2bxzfj93foohf">{s.sub}</p>
              </div>
              {i < steps.length - 1 && <ArrowRight className="absolute -right-3 top-1/2 z-10 hidden h-5 w-5 -translate-y-1/2 rounded-full bg-white text-navy-400 xl:block" data-id="element-3786" data-mp="2gwkfr8ior85v" />}
            </li>)}
        </ol>
        <div className="my-4 flex justify-center" data-id="element-3787" data-mp="2pxino1w8vztq"><ArrowDown className="h-6 w-6 text-navy-300" data-id="element-3788" data-mp="2pwh9hojxmx7s" /></div>
        <div className="grid gap-4 md:grid-cols-2" data-id="element-3789" data-mp="1t9uei9e5vhmb">
          <Link to="/mobile" className="rounded-lg border-2 border-emerald-600 bg-emerald-50 p-5 hover:bg-emerald-100" data-id="element-3790" data-mp="1y7e6ec3s7swq">
            <div className="flex items-center gap-3" data-id="element-3791" data-mp="228zdthxjrezj">
              <CheckCircle2 className="h-10 w-10 text-emerald-600" data-id="element-3792" data-mp="2274v8a9qzyym" />
              <div data-id="element-3793" data-mp="270r4dsgpdkpo">
                <p className="text-xs font-semibold text-emerald-700" data-id="element-3794" data-mp="2722aw01j96kh">সব তথ্য বৈধ হলে</p>
                <p className="font-heading text-xl font-bold text-emerald-800" data-id="element-3795" data-mp="1aht9sqepgx4z">বৈধ হলে যাত্রা অব্যাহত</p>
              </div>
            </div>
            <p className="mt-3 text-sm text-emerald-900" data-id="element-3796" data-mp="16zvtxds723te">“যাচাই সফল” রেকর্ড কেন্দ্রীয় সার্ভারে সংরক্ষিত হয়; গাড়ি ও চালককে দ্রুত ছেড়ে দেওয়া হয় — অযথা হয়রানি কমে।</p>
          </Link>
          <Link to="/admin/irregularities" className="rounded-lg border-2 border-red-600 bg-red-50 p-5 hover:bg-red-100" data-id="element-3797" data-mp="xzfs08r3n4qn">
            <div className="flex items-center gap-3" data-id="element-3798" data-mp="t0w628ci9sya">
              <AlertOctagon className="h-10 w-10 text-red-600" data-id="element-3799" data-mp="t2gzfun335uk" />
              <div data-id="element-3800" data-mp="o2bd8tzl2bjv">
                <p className="text-xs font-semibold text-red-700" data-id="element-3801" data-mp="o2upbu2jy5pz">অথবা (OR)</p>
                <p className="font-heading text-xl font-bold text-red-800" data-id="element-3802" data-mp="j9i7q3waiz6q">অনিয়ম হলে ব্যবস্থা গ্রহণ</p>
              </div>
            </div>
            <p className="mt-3 text-sm text-red-900" data-id="element-3803" data-mp="e9dow77wtsdc">অননুমোদিত চালক, মেয়াদোত্তীর্ণ লাইসেন্স/ফিটনেস বা নকল QR — অ্যাপ থেকে ছবি ও GPS সহ রিপোর্ট; কন্ট্রোল রুমে তাৎক্ষণিক কেস তৈরি।</p>
          </Link>
        </div>
      </Panel>
    </div>;
}